class Product extends HTMLElement {
  constructor() {
    super();

    this.productForm();
    this.productTabs();
    if (window.innerWidth > 991) {
      this.productImages();
    }
    this.productSizeGuide();
    this.klaviyoBackInStock();
    this.productColors();
    this.handleBackToProductButton();
    if (window.innerWidth > 991) {
      this.productCustomCursor();
    }
    this.productCoOrdinating();
  }

  productForm() {
    const variants = (productId, sectionId) => {
      const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

      const selectCallback = (variant) => {
        const that = this.querySelector(`.js-product[data-product-id='${productId}']`);

        if (variant) {
          const priceOldElement = that.querySelector(".js-price-old");
          const priceNewElement = that.querySelector(".js-price-new");
          const priceDefaultElement = that.querySelector(".js-price-default");

          if (variant.compare_at_price > variant.price) {
            if (priceOldElement) {
              priceOldElement.classList.remove("d-none");
              priceOldElement.innerHTML = Shopify.formatMoney(variant.compare_at_price);
            }
            if (priceNewElement) {
              priceNewElement.classList.remove("d-none");
              priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if (priceDefaultElement) {
              priceDefaultElement.classList.add("d-none");
            }
          } else {
            if (priceOldElement) priceOldElement.classList.add("d-none");
            if (priceNewElement) priceNewElement.classList.add("d-none");
            if (priceDefaultElement) {
              priceDefaultElement.classList.remove("d-none");
              priceDefaultElement.innerHTML = Shopify.formatMoney(variant.price);
            }
          }

          const soldOutWrappers = that.querySelectorAll('.js-wrap-sold-out');
          const addToCartWrappers = that.querySelectorAll('.js-wrap-add-to-cart');

          if (!variant.available) {
            soldOutWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
          } else {
            soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
          }

          that.querySelectorAll('.js-product-size').forEach(sizeElement => {
            let soldOut = true;
            const value = sizeElement.getAttribute('data-value');
            const option = sizeElement.getAttribute('data-option');

            const selectedOptions = {};
            that.querySelectorAll(`.selector-wrapper select`).forEach(select => {
              const optionName = select.getAttribute('data-option');
              if(optionName != option) {
                selectedOptions[optionName] = select.value;
              }
            });

            that.querySelectorAll(`select[name='id'] option`).forEach(option => {
              const option1 = option.getAttribute('data-option-1');
              const option2 = option.getAttribute('data-option-2');
              const option3 = option.getAttribute('data-option-3');

              const matchesSelectedOptions =
                  (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                  (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                  (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

              if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                if (!option.hasAttribute('disabled')) {
                  soldOut = false;
                }
              }
            });

            if (soldOut) {
              sizeElement.classList.add('out-of-stock');
            } else {
              sizeElement.classList.remove('out-of-stock');
            }
          });

          const selectedOption = that.querySelector("select[name='id'] option:checked");
          const selectedOptionQuantity = that.querySelector('.js-last-new-remaining-quantity');
          const quantity = parseInt(selectedOption?.getAttribute('data-quantity'), 10);

          if (selectedOptionQuantity && !isNaN(quantity)) {
            selectedOptionQuantity.innerHTML = quantity;
          }

          const lastFew = that.querySelector('.js-last-few-remaining');
          const lastFewOutOfStock = that.querySelector('.js-last-few-remaining-out-of-stock');

          if (isNaN(quantity) || quantity < 4) {
            if(quantity > 0) {
              lastFew?.classList.remove('d-none');
              lastFewOutOfStock?.classList.add('d-none');
            } else {
              lastFew?.classList.add('d-none');
              lastFewOutOfStock?.classList.remove('d-none');
            }
          } else {
            lastFew?.classList.add('d-none');
            lastFewOutOfStock?.classList.add('d-none');
          }

          if(selectedOption) {
            var addToCartBtn = this.querySelector(".js-add-to-cart");
            var preOrderText = addToCartBtn.getAttribute("data-preorder-text");
            var originalText = addToCartBtn.getAttribute("data-original-text");
            var preOrderInfo = this.querySelector(".js-product-pre-order-text");

            var continueSelling = selectedOption.getAttribute("data-continue-selling-when-out-of-stock") === "true";

            if(addToCartBtn) {
              if (continueSelling && quantity < 1 && preOrderInfo) {
                addToCartBtn.textContent = preOrderText;

                soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
                addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));

                if(preOrderInfo) {
                  preOrderInfo.classList.remove("d-none");
                }
              } else {
                addToCartBtn.textContent = originalText;

                if(preOrderInfo) {
                  preOrderInfo.classList.add("d-none");
                }
              }
            }
          }
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }
    };

    document.querySelectorAll(".js-product:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll('.js-product-size').forEach(sizeElement => {
          sizeElement.addEventListener('click', function (event) {
            event.preventDefault();

            const value = this.getAttribute('data-value');
            const option = this.closest('ul').getAttribute('data-option');

            const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));

              const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`);
              if (optionValues.length) {
                optionValues.forEach(optionValue => {
                  optionValue.classList.remove('active');
                });

                this.classList.add('active');
              }
            }
          });
        });
      }

      element.classList.add("active");
    });
  }

  productTabs() {
    document.querySelectorAll('.js-product-tab').forEach(tab => {
      const height = tab.scrollHeight;
      tab.setAttribute('data-height', height);
      tab.style.height = `${height}px`;
    });

    document.querySelectorAll('.js-toggle-product-tab').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const tab = button.closest('.js-product-tab');
        const savedHeight = tab.getAttribute('data-height');

        if (tab.classList.contains('active')) {
          tab.classList.remove('active');
          tab.classList.add('deactivate');
          tab.style.height = `${savedHeight}px`;

          setTimeout(() => {
            tab.classList.remove('deactivate', 'display');
          }, 300);
        } else {
          tab.classList.add('display');

          setTimeout(() => {
            const height = tab.scrollHeight;
            tab.style.height = `${height}px`; 
            tab.classList.add('active');
          }, 10);
        }
      });
    });
  }

  productImages() {
    document.querySelectorAll('.js-open-product-zoom').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const index = button.getAttribute('data-index');

        document.querySelectorAll('.js-product-thumbnail').forEach(thumbnail => {
          thumbnail.classList.toggle('active', thumbnail.getAttribute('data-index') === index);
        });

        document.querySelectorAll('.js-product-media').forEach(media => {
          if (media.getAttribute('data-index') === index) {
            media.classList.add('active');
            media.classList.remove('d-none');
          } else {
            media.classList.remove('active');
            media.classList.add('d-none');
          }
        });

        const zoom = document.querySelector('.js-product-image-zoom');
        if (zoom) {
          zoom.classList.add('display');
          setTimeout(() => {
            zoom.classList.add('active');
          }, 50);
        }
      });
    });

    function closeZoom() {
      const zoom = document.querySelector('.js-product-image-zoom');
      if (!zoom) return;

      zoom.classList.add('deactivate');
      setTimeout(() => {
        zoom.classList.remove('deactivate', 'active', 'display');
      }, 300);
    }

    const closeButton = document.querySelector('.js-close-product-image-zoom');
    if (closeButton) {
      closeButton.addEventListener('click', closeZoom);
    }

    document.querySelectorAll('.js-product-media').forEach(media => {
      media.addEventListener('click', closeZoom);
    });

    document.querySelectorAll('.js-product-thumbnail').forEach(thumbnail => {
      thumbnail.addEventListener('mouseenter', () => {
        const index = thumbnail.getAttribute('data-index');

        document.querySelectorAll('.js-product-media').forEach(media => {
          media.classList.add('d-none');
        });

        const targetMedia = document.querySelector('.js-product-media[data-index="' + index + '"]');
        if (targetMedia) {
          targetMedia.classList.remove('d-none');
        }

        document.querySelectorAll('.js-product-thumbnail').forEach(t => {
          t.classList.remove('active');
        });
        thumbnail.classList.add('active');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeZoom();
      }
    });
  }

  productSizeGuide() {
    const toggleBtn = document.querySelector('.js-toggle-size-guide-table-switcher');
    const tableCells = document.querySelectorAll('.js-size-table td');
    const originalValues = [];

    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function () {
      toggleBtn.classList.toggle('active');

      tableCells.forEach((cell, index) => {
        const text = cell.textContent.trim();
        const numberOnly = text.replace(',', '.').match(/^(\d+(\.\d+)?)(\s*cm)?$/i);

        if (toggleBtn.classList.contains('active')) {
          if (numberOnly) {
            const cm = parseFloat(numberOnly[1]);
            originalValues[index] = cm;
            const inches = (cm / 2.54).toFixed(2);
            cell.textContent = `${inches}"`;
          }
        } else {
          const cm = originalValues[index];
          if (cm !== undefined) {
            cell.textContent = `${cm} cm`;
          }
        }
      });
    });

    document.querySelectorAll('.js-open-size-guide').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const guide = document.querySelector('.js-size-guide');
        if (!guide) return;

        guide.classList.add('display');

        setTimeout(() => {
          guide.classList.add('active');
        }, 50);
      });
    });

    document.querySelectorAll('.js-close-size-guide').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        
        const guide = document.querySelector('.js-size-guide');
        if (!guide) return;

        guide.classList.add('closing');

        setTimeout(() => {
          guide.classList.remove('display', 'active', 'closing');
        }, 300);
      });
    });
  }

  klaviyoBackInStock() {
    document.body.addEventListener("click", function(event) {
      const target = event.target.closest(".js-wrap-sold-out a");
      if (target) {
        if (typeof refreshKlaviyoBIS === 'function') refreshKlaviyoBIS();
        setTimeout(function () {
          const bisTrigger = document.querySelector(".klaviyo-bis-trigger");
          if (bisTrigger) bisTrigger.click();
        }, 1000);
        event.preventDefault();
      }
    });
  }

  productColors() {
    document.querySelectorAll('.js-product-get-color-image').forEach(link => {
      const handle = link.getAttribute('href').split('/products/')[1].replace('.js', '');

      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => {
          const img = document.createElement('img');
          img.src = product.featured_image + '&width=200';
          img.alt = product.title;

          link.appendChild(img);
        })
        .catch(error => console.error(error));
    });
  }

  handleBackToProductButton() {
    function checkVisibility() {
      const button = document.querySelector('.js-product-form-button');
      const backButton = document.querySelector('.js-back-to-product');
      if (!button || !backButton) return;

      const rect = button.getBoundingClientRect();
      const isAbove = rect.bottom < 0;
      
      backButton.classList.toggle('active', isAbove);
    }

    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);
    checkVisibility();

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-back-to-product')) {
        const button = document.querySelector('.js-product-form-button');
        if (button) {
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  productCustomCursor() {
    const cursor = document.querySelector('.js-product-media-custom-cursor');
    const cursorText = cursor?.querySelector('span');

    if (!cursor || !cursorText) return;

    document.addEventListener('mousemove', (e) => {
      cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
    });

    let hoverCount = 0;

    document.querySelectorAll('.js-product-media, .js-open-product-zoom').forEach(media => {
      media.addEventListener('mouseenter', () => {
        hoverCount++;
        cursor.classList.add('active');
      });

      media.addEventListener('mouseleave', () => {
        hoverCount = Math.max(0, hoverCount - 1);
        if (hoverCount === 0) {
          cursor.classList.remove('active');
        }
      });
    });

    const updateCursorSymbol = () => {
      const zoom = document.querySelector('.js-product-image-zoom');
      if (!zoom || !cursorText) return;
      cursorText.textContent = zoom.classList.contains('active') ? '-' : '+';
    };

    const zoomElement = document.querySelector('.js-product-image-zoom');
    if (zoomElement) {
      const observer = new MutationObserver(updateCursorSymbol);
      observer.observe(zoomElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
      updateCursorSymbol();
    }
  }

  productCoOrdinating() {
    const variants = (productId, sectionId) => {
      const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

      const checkAllOptionsSelected = (wrapper) => {
        const totalOptions = wrapper.querySelectorAll('.js-product-grid-item-sizes');
        let allSelected = true;

        totalOptions.forEach(optionGroup => {
          const isVisible = optionGroup.offsetParent !== null;
          if (!isVisible) return;

          const hasActive = optionGroup.querySelector('.js-product-size-1.active, .js-product-size-2.active, .js-product-size-3.active');
          if (!hasActive) {
            allSelected = false;
          }
        });

        return allSelected;
      };

      const selectCallback = (variant) => {
        const that = this.querySelector(`.js-co-ordinating-product-2[data-product-id='${productId}']`);

        if (variant) {
          that.querySelectorAll('.js-product-size-1, .js-product-size-2, .js-product-size-3').forEach(sizeElement => {
            const value = sizeElement.getAttribute('data-value');
            const option = sizeElement.getAttribute('data-option');
            const parentSizes = sizeElement.closest('.js-product-grid-item-sizes');
            const dataIndex = parentSizes?.getAttribute('data-index') || "1";

            let soldOut = true;

            if (dataIndex === "1") {
              document.querySelectorAll(`.js-co-ordinating-product[data-product-id='${productId}'] select[name='id'] option`).forEach(optionEl => {
                const option1 = optionEl.getAttribute('data-option-1');
                const option2 = optionEl.getAttribute('data-option-2');
                const option3 = optionEl.getAttribute('data-option-3');

                const optionMatches = option1 === value || option2 === value || option3 === value;

                if (optionMatches && !optionEl.disabled && !optionEl.hasAttribute('disabled')) {
                  soldOut = false;
                }
              });
            } else {
              const selectedOptions = {};
              document.querySelectorAll(`.js-co-ordinating-product[data-product-id='${productId}'] .selector-wrapper select`).forEach(select => {
                const optionName = select.getAttribute('data-option');
                if (optionName !== option) {
                  selectedOptions[optionName] = select.value;
                }
              });

              document.querySelectorAll(`.js-co-ordinating-product[data-product-id='${productId}'] select[name='id'] option`).forEach(optionEl => {
                const option1 = optionEl.getAttribute('data-option-1');
                const option2 = optionEl.getAttribute('data-option-2');
                const option3 = optionEl.getAttribute('data-option-3');

                const matchesSelectedOptions =
                  (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                  (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                  (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

                if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                  if (!optionEl.disabled && !optionEl.hasAttribute('disabled')) {
                    soldOut = false;
                  }
                }
              });
            }

            if (soldOut) {
              sizeElement.classList.add('out-of-stock');
            } else {
              sizeElement.classList.remove('out-of-stock');
            }
          });
          
          if (variant.available) {
            setTimeout(() => {
              const addToCartBtn = document.querySelector(`.js-co-ordinating-product[data-product-id='${productId}'] .js-add-to-cart`);
              if (checkAllOptionsSelected(that) && addToCartBtn) {
                addToCartBtn.click();
              }
            }, 100);
          }
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }
    };

    document.querySelectorAll(".js-co-ordinating-product-2:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll('.js-product-size-1, .js-product-size-2, .js-product-size-3').forEach(sizeElement => {
          sizeElement.addEventListener('click', function (event) {
            event.preventDefault();

            const value = this.getAttribute('data-value');
            const option = this.closest('ul').getAttribute('data-option');

            const productVariants = document.querySelector(`.js-co-ordinating-product[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));

              const optionValues = document.querySelectorAll(`.js-co-ordinating-product-2[data-product-id='${productId}'] .js-product-size-1[data-option="${option}"], .js-co-ordinating-product-2[data-product-id='${productId}'] .js-product-size-2[data-option="${option}"], .js-co-ordinating-product-2[data-product-id='${productId}'] .js-product-size-3[data-option="${option}"]`);
              if (optionValues.length) {
                optionValues.forEach(optionValue => {
                  optionValue.classList.remove('active');
                });

                this.classList.add('active');
              }
            }
          });
        });
      }

      element.classList.add("active");
    });
  }
}

if(document.querySelector("product-page")) {
  customElements.define("product-page", Product);
}